import AccessControlLayout from "../layouts/AccessControlLayout";
import { Item, Loader as ItemLoader } from '../pages/girder/item';
import ItemAnnotate from '../pages/girder/ItemAnnotate';
import { Folder, Loader as FolderLoader } from '../pages/girder/folder';
import { Collection, CollectionList, Loader as CollectionLoader, CollectionListLoader } from '../pages/girder/collection';
import BdsaItemsTable from '../pages/girder/BdsaItemsTable';
import Base from "../layouts/Base";
import ErrorPage from '../pages/ErrorPage';

const GirderRoutes = {
    element: <AccessControlLayout/>,
    errorElement: <ErrorPage/>,
    children:[
        {
            element:<Base/>,
            children:[
                {
                    path: '/collections',
                    element: <CollectionList/>,
                    loader: CollectionListLoader
                },
                {
                    path: '/bdsa/items',
                    element: <BdsaItemsTable/>
                },
                {
                    path: '/collection/:collectionId',
                    element: <Collection/>,
                    loader: CollectionLoader
                },
                {
                    path: '/folder/:folderId',
                    element: <Folder/>,
                    loader: FolderLoader
                },
            ]
        },
        {
            children:[
                {
                    path: '/item/:itemId',
                    element: <Item/>,
                    loader: ItemLoader
                },
                {
                    path: '/item/:itemId/annotate',
                    element: <ItemAnnotate/>,
                    loader: ItemLoader
                },
            ]
        },
    ]
}

export default GirderRoutes;